<div class="payment-required-container" *transloco="let t">
	<div class="content">
		@if (isBrowser) {
			<ng-lottie [options]="options" class="lottie-animation"></ng-lottie>
		}

		<h1 class="title">{{ t('paymentRequired.title') }}</h1>

		<p class="description">
			{{ t('paymentRequired.description') }}
			<br />
			{{ t('paymentRequired.contactInfo') }}
		</p>

		<div class="actions">
			<app-button
				[label]="t('paymentRequired.backToDashboard')"
				variant="secondary"
				size="medium"
				(onClick)="goToDashboard()">
			</app-button>

			<app-button
				[label]="t('paymentRequired.contactSupport')"
				variant="primary"
				size="medium"
				(onClick)="contactSupport()">
			</app-button>
		</div>
	</div>
</div>
